<template>
    <div class="col-12">
        <div class="mt-2">
            <br>
            <input type="text" class="form-control" placeholder="Search customer..."
                v-model="search">
            <br>
        </div>        
            <div class="p-2" style="height: 50vh; overflow-y:scroll;"
                id="customers_table_div">
                <table class="table table-borderless" id="customersTable">                   
                    <tbody>
                        <!-- initially selected row -->                     
                        <tr class="cursor-pointer" @click="selectCustomer(customer)" 
                            v-for="customer in customers" :key="customer.id">                           			
                            <td>{{customer.name}}</td>
                            <td >{{customer.phone}}</td>                             
                        </tr>		                           				
                    </tbody>
                </table>
            </div>		
    </div>
</template>
    
<script>
export default {
    name: 'SearchCustomers',
    props: {
        msg: String
    },
    data(){
        return{
            search:null,
            customers:null
        }
    },
    created(){
        this.getCustomers()
    },
    computed:{     
		account_switched(){
			return this.$store.state.account_switch_count
        }
    },
    watch:{      
        account_switched: function(){
			this.getCustomers()
		}, 
        search:function(){			
            this.$searchTable('customersTable',this.search)			
        }
    },   
    methods:{		
        //get_products
        getCustomers: function(){            
            this.$http({
                method:'get',				
                url: this.$API_BASE_URL + `/HJYBCFRB/${this.$version}/customers/`,
                headers:{			
                    Authorization: JSON.parse(localStorage.getItem('auth_token'))
                }
            }).then((response)=>{
                this.customers = response.data
            }).catch((err)=>{
                this.$emit('alert',err)
            })
        },
        selectCustomer: function(customer){
            this.$emit('input',customer)
        }
    }
}
</script>
<style scoped>
    #customers_table_div:hover{    
        overflow-y: scroll; 
    }
</style>